import storage from "../../storage"
import { navigation } from "../navigation"

export function PasswordChangeVerifyGuard(to, from, next) {
    const passwordChanged = storage.local.getPasswordChanged()

    if (passwordChanged)
        return next(navigation.main.reports)

    return next()
}
